export default __webpack_public_path__ + "static/premio-bo-03bdcc1b7c4043b0056dbf99ea8c441c.png";